import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { rem } from 'polished';
import { TimePickerDropdown } from './TimePickerDropdown';
import { AddToCalendarField, Subtitle } from './styles';
import { DurationDropdown } from './DurationDropdown';
import { DayDropdownDropdown } from './DayDropdown';

const Dropdown = styled.div`
  width: 100%;
`;

const TimeDurationContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; /* Creates two equal columns */
  gap: ${rem(12)};
  width: 100%;
  margin-top: ${rem(12)};
`;

interface DateTimeDurationSelectorGroupProps {
  date: Date;
  duration: number;
  onSelect(field: string, value: Date | string | number): void;
}

export const DateTimeDurationSelectorGroup = ({
  date,
  duration,
  onSelect,
}: DateTimeDurationSelectorGroupProps) => {
  const { t: translate } = useTranslation('shared');

  return (
    <AddToCalendarField multipleFields>
      <Dropdown>
        <DayDropdownDropdown date={date} onSelect={onSelect} />
        <Subtitle>
          {translate('add_to_calendar.modal.time_and_duration')}
        </Subtitle>
        <TimeDurationContainer role="group">
          <TimePickerDropdown date={date} onSelect={onSelect} />
          <DurationDropdown onSelect={onSelect} duration={duration} />
        </TimeDurationContainer>
      </Dropdown>
    </AddToCalendarField>
  );
};
